// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"532":"a31e1980","584":"b840271e","629":"8f47a176","726":"b4797cb2","761":"dea32817","916":"0da7f107"}[chunkId] + ".chunk.css";
};